// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cfe67d1e","87":"9d52eb38","121":"adfef0bb","163":"16460d5c","251":"1a4ffae7","444":"eca3bf97","460":"e92cc32f","606":"dca3edc8","693":"b2b1ecef","767":"5bef6ff0","830":"c9c1db89"}[chunkId] + ".chunk.js";
};